// extracted by mini-css-extract-plugin
export default {"slider":"style_slider__h+NMS"};